module.exports = kolibriGlobal.coreVue.components.BirthYearDisplayText;